<router-outlet #o='outlet' [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''"></router-outlet>
